import React from 'react';
import { useLocale } from '../i18n/LocaleContext';
import { getCategoryById } from '../utils/eventCategories';
import { musicGroupIcon } from '../utils/musicGroups';
import { CloseIcon } from './Icons';

// Every applied filter is visible and removable in one click - no need to
// reopen the drawer to find out why the list is short.
export default function ActiveFilters({ filters, searchQuery, onRemove, onClearSearch }) {
  const { t } = useLocale();
  const pills = [];

  if (searchQuery.trim()) {
    pills.push({ key: 'search', label: `"${searchQuery.trim()}"`, remove: onClearSearch });
  }

  for (const id of filters.categories) {
    const category = getCategoryById(id);
    pills.push({
      key: `cat-${id}`,
      label: `${category.icon} ${t(`cat.${id}`)}`,
      remove: () => onRemove('categories', id)
    });
  }

  for (const district of filters.districts) {
    pills.push({
      key: `dist-${district}`,
      label: t('district.label', { district }),
      remove: () => onRemove('districts', district)
    });
  }

  for (const id of filters.musicGroups || []) {
    pills.push({
      key: `music-${id}`,
      label: `${musicGroupIcon(id)} ${t(`music.${id}`)}`,
      remove: () => onRemove('musicGroups', id)
    });
  }

  for (const genre of filters.music_genre) {
    pills.push({ key: `genre-${genre}`, label: genre, remove: () => onRemove('music_genre', genre) });
  }

  for (const feature of filters.special_features) {
    pills.push({
      key: `feat-${feature}`,
      label: feature,
      remove: () => onRemove('special_features', feature)
    });
  }

  for (const key of ['city', 'country', 'venue']) {
    if (filters[key]) {
      pills.push({ key, label: filters[key], remove: () => onRemove(key) });
    }
  }

  if (filters.freeOnly) {
    pills.push({ key: 'free', label: t('quick.free'), remove: () => onRemove('freeOnly') });
  }

  if (filters.dateFrom || filters.dateTo) {
    pills.push({
      key: 'dates',
      label: filters.quickDate
        ? t(`quick.${filters.quickDate}`)
        : [filters.dateFrom, filters.dateTo].filter(Boolean).join(' – '),
      remove: () => onRemove('dates')
    });
  }

  if (pills.length === 0) {
    return null;
  }

  return (
    <div className="rail" aria-label={t('filters.active')}>
      {pills.map((pill) => (
        <button
          key={pill.key}
          type="button"
          className="chip chip--sm chip--removable"
          onClick={pill.remove}
        >
          {pill.label}
          <span className="chip__remove">
            <CloseIcon size={13} />
          </span>
        </button>
      ))}
    </div>
  );
}
